import { render, staticRenderFns } from "./EmailReconfirm.vue?vue&type=template&id=945a9a6a&scoped=true&"
import script from "./EmailReconfirm.vue?vue&type=script&lang=js&"
export * from "./EmailReconfirm.vue?vue&type=script&lang=js&"
import style0 from "./EmailReconfirm.vue?vue&type=style&index=0&id=945a9a6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945a9a6a",
  null
  
)

export default component.exports